var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"dataset-hash"},[_c('i',[_vm._v(_vm._s(_vm.hash.hash_value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }